import React from "react"
import styled from "styled-components"

import Label from "../../../elements/label"

import media from "../../../../styles/media"

const Container = styled.header`
  padding: var(--gutter-s) 0 0 0;
  ${media.tablet`
    padding: var(--gutter-s) 0 0 var(--gutter-s);
  `}
`

const Header = ({ ...props }) => {
  return (
    <Container {...props}>
      <Label
        pLeft={1.5}
        mLeft={1}
        outerRotate={0}
        innerRotate={-1}
        fontScaled
        fontSize={0.8}
        value="Brainfarm presents a"
        url="http://brainfarm.co.za/"
      />
      <br />
      <Label
        pLeft={2}
        mLeft={0.5}
        outerRotate={-1}
        innerRotate={-1}
        fontScaled
        fontSize={1}
        value="Ryan Holiday masterclass feat."
      />
      <br />
      <Label
        outerRotate={0}
        innerRotate={0}
        fontScaled
        fontSize={1}
        value="an in conversation session with"
      />
      <br />
      <Label
        pLeft={2}
        pRight={2.5}
        mLeft={0}
        mRight={1}
        outerRotate={-1}
        innerRotate={0}
        fontScaled
        fontSize={1}
        value="Black Coffee on conquering"
      />
      <br />
      <Label
        pLeft={1}
        pRight={1.5}
        mLeft={1}
        mRight={0}
        outerRotate={1}
        innerRotate={-1}
        fontScaled
        fontSize={1}
        value="international markets"
      />
    </Container>
  )
}

export default Header
